import { BannerContent } from '@shared/types/contentful';
import { useQueryClient } from '@tanstack/react-query';

import useContent from './useContent';

export default function useBannerContent(contentType: string) {
    const queryClient = useQueryClient();

    queryClient.setMutationDefaults([contentType], {
        mutationFn: (entry: BannerContent) => {
            const data: BannerContent[] = queryClient.getQueryData(['contentByType', contentType]);

            data.forEach(e => {
                if (e.bannerMessage === entry.bannerMessage && e.severity === entry.severity) {
                    e = entry;
                    return;
                }
            });

            queryClient.setQueryData(['contentByType', contentType], () => data);

            return Promise.resolve();
        },
    });
    return useContent<BannerContent>({ contentType });
}
